import _sfc_main from "./BuyBoxPurchaseForm2.mjs";
/* empty css                     */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxPurchaseForm = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-f3e28235"]]);
export {
  BuyBoxPurchaseForm as default
};
//# sourceMappingURL=BuyBoxPurchaseForm.mjs.map
